import ForgotPassword from "./ForgotPassword";
import LogIn from "./LogIn";
import SetPassword from "./SetPassword";
import SignUp from "./SignUp";
import AuthConfirmation from "./AuthConfirmation";
import GithubRedirect from "./GithubRedirect";
import SelectWorkspace from "./SelectWorkspace";
import * as selectors from "./authScreens.selectors";
import * as slice from "./authScreens.reducers";
import * as useQueryActions from "./authScreens.actions";

export const {
  name,
  actions: { setPrevPathName, setShouldShowNav },
  reducer,
} = slice;

export const { selectPrevPathName, selectShouldShowNav, selectGithubUser } =
  selectors;

export const { createGithubUser } = useQueryActions;

export {
  ForgotPassword,
  LogIn,
  SetPassword,
  SignUp,
  AuthConfirmation,
  GithubRedirect,
  SelectWorkspace,
};
